const StepsDots = ({ activeStep,steps=[1, 2, 3] }) => {
  return (
    <div class="ct_step_slider_dots">
      {steps.map((item,index) => {
        return (
          <>
            <span class={item == activeStep ? "active" : ""} key={index}></span>
          </>
        );
      })}
    </div>
  );
};

export default StepsDots;
